import Enums from '@/config/enums.config';
import anime from 'animejs/lib/anime.es.js';

export default {
  name: 'BroadcastBox',
  props: {
    broadcastList: Array,
    isUseOpenVideo: Boolean
  },
  data() {
    return {
      topList: [],
      bottomList: [],
      Enums
    };
  },
  watch: {
    broadcastList: {
      immediate: true,
      handler: 'setGroup'
    }
  },
  methods: {
    // 给广播分组
    setGroup(broadcastList) {
      if (broadcastList.length > 0) {
        broadcastList.forEach((item, index) => {
          if (index % 2) {
            this.topList.push(item);
          } else {
            this.bottomList.push(item);
          }
        });

        this.$nextTick(() => {
          this.initBarrage();
        });
      }
    },

    // 初始化弹幕
    initBarrage() {
      // 获取屏幕宽度
      let screenWidth = document.documentElement.clientWidth;

      // 设置单行弹幕的容器宽度
      // 以barrage__line容器为基准
      let barrageLineList = document.querySelectorAll('.barrage__line');

      barrageLineList.forEach((barrageLine, lineIndex) => {
        // 遍历其元素累加距离
        let lineWidth = 0;

        if (barrageLine.children?.length > 0) {
          for (let i = 0; i < barrageLine.children.length; i++) {
            let barrageItemStyle = window.getComputedStyle(barrageLine.children[i]);
            lineWidth += Number(barrageItemStyle.getPropertyValue('width').split('px')[0] || 0);
            lineWidth += Number(
              barrageItemStyle.getPropertyValue('margin-right').split('px')[0] || 0
            );
          }
        }

        barrageLine.style.width = `${lineWidth}px`;

        // 将元素初始设置到屏幕外不可见
        barrageLine.classList.add('barrage__line_active');

        let barrageMove = {
          targets: `#barrageLine_${lineIndex}`,
          duration: (lineWidth + screenWidth) * (1000 / 130) * (this.isUseOpenVideo ? 2 : 1),
          loop: true,
          delay: 500 * lineIndex + 1000 * Math.random() * (this.isUseOpenVideo ? 2 : 1),
          translateX: {
            value: -lineWidth - screenWidth,
            easing: 'linear'
          }
        };
        this.barrageAnima[lineIndex] = anime(barrageMove);
      });
    }
  },
  mounted: function() {
    this.barrageAnima = [];
  }
};
